export const LOGIN_START = 'LOGIN_START';
export const AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS';
export const AUTHENTICATION_FAIL = 'AUTHENTICATION_FAIL';
export const EMAIL_CONFIRMED = 'EMAIL_CONFIRMED';

export const SIGN_UP_START = 'SIGN_UP_START';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';

export const LOGOUT = 'LOGOUT';


// WEBPACK FOOTER //
// ./src/store/modules/authentication/actions.ts